import { LawyerStatus } from '@/modules/lawyer/enums/LawyerStatus';
import { LawyerStatusKey } from '@/modules/lawyer/constants/LawyerStatusKey';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class WorkflowLawyerStatusTrigger extends BaseEntityModel {
  id?: number;

  status?: string;

  constructor(model: Partial<WorkflowLawyerStatusTrigger> = {}) {
    super(model);

    this.id = model.id;
    this.status = model.status;
  }

  get statusText(): string {
    return LawyerStatus.getByKey(this.status as LawyerStatusKey)?.value ?? '';
  }

  get statusColor(): string {
    return LawyerStatus.getByKey(this.status as LawyerStatusKey)?.color ?? '';
  }
}
